import type { ReactNode } from "react";

const useMultilineText = (text: string): ReactNode => {
  if (!text) {
    return null;
  }
  return (
    <div>
      {text.split("\n").map((part) => (
        <>
          {part}
          <br />
        </>
      ))}
    </div>
  );
};

export { useMultilineText };
